import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
import { createEstimateRequestSchema, updateEstimateRequestSchema } from './estimate.js';
/**
 * One unsent action stored in Dexie. The outbox drains in insertion order when signal returns,
 * and from the Waiting tab. `attempts` and `lastError` exist for diagnostics, never for copy:
 * the grower only ever sees "Waiting for signal".
 */
export const outboxItemSchema = z.discriminatedUnion('kind', [
    z.object({
        id: idSchema,
        kind: z.literal('create'),
        estimateId: idSchema,
        payload: createEstimateRequestSchema,
        createdAt: isoDateTimeSchema,
        attempts: z.number().int().min(0),
        lastError: z.string().optional(),
    }),
    z.object({
        id: idSchema,
        kind: z.literal('update'),
        estimateId: idSchema,
        payload: updateEstimateRequestSchema,
        createdAt: isoDateTimeSchema,
        attempts: z.number().int().min(0),
        lastError: z.string().optional(),
    }),
    z.object({
        id: idSchema,
        kind: z.literal('delete'),
        estimateId: idSchema,
        createdAt: isoDateTimeSchema,
        attempts: z.number().int().min(0),
        lastError: z.string().optional(),
    }),
]);
//# sourceMappingURL=outbox.js.map